import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addLanguage,
  deleteLanguage,
  getLanguages,
  updateLanguage,
  updateDefaultLanguage,
} from "store/services/dataManagement/language";
import { closeAdminModal } from "store/slices/common/adminModal.slice";
import { openToast } from "store/slices/common/toast.slice";
import { getApiMessage } from "utils/apiErrorCode";

export const GetAllLanguagesAction = createAsyncThunk(
  "languages/getAllLanguages",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await getLanguages(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        return fulfillWithValue(res);
      }
      return rejectWithValue(res);
    } catch (error) {
      //     dispatch(handleAuthError({status: error?.response?.status}));
      return rejectWithValue(error);
    }
  }
);

export const DeleteLanguageAction = createAsyncThunk(
  "languages/deleteLanguage",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await deleteLanguage(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        return fulfillWithValue({ ...res, ...payload });
      }
      dispatch(openToast({ type: "error", message: res?.message }));
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        })
      );
      //     dispatch(handleAuthError({status: error?.response?.status}));
      return rejectWithValue(error);
    }
  }
);

export const UpdateLanguageAction = createAsyncThunk(
  "languages/updateLanguage",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await updateLanguage(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data
        dispatch(closeAdminModal());

        return fulfillWithValue(res);
      }
      dispatch(openToast({ type: "error", message: res?.message }));
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        })
      );
      //     dispatch(handleAuthError({status: error?.response?.status}));
      return rejectWithValue(error);
    }
  }
);

export const AddLanguageAction = createAsyncThunk(
  "languages/addLanguage",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      // if any async operation need to be done on response data, do it here,
      // then full fill data
      const res = await addLanguage(payload);
      if (res.status === 1) {
        dispatch(closeAdminModal());

        return fulfillWithValue(res);
      }
      dispatch(openToast({ type: "error", message: res?.message }));
      return rejectWithValue({ message: res?.message });
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data
            ? error?.response?.data?.message
            : error?.message,
        })
      );
      //     dispatch(handleAuthError({status: error?.response?.status}));
      return rejectWithValue(error);
    }
  }
);

export const UpdateDefaultLanguageAction = createAsyncThunk(
  "languages/updateDefaultLanguage",
  async (payload, { rejectWithValue, dispatch, fulfillWithValue }) => {
    try {
      const res = await updateDefaultLanguage(payload);
      if (res.status === 1) {
        // if any async operation need to be done on response data, do it here,
        // then full fill data

        dispatch(closeAdminModal());
        return fulfillWithValue(res);
      }
      dispatch(
        openToast({ type: "error", message: getApiMessage(res?.statusCode) })
      );
      return rejectWithValue(res);
    } catch (error) {
      dispatch(
        openToast({
          type: "error",
          message: error?.response?.data?.statusCode
            ? getApiMessage(error?.response?.data?.statusCode)
            : error?.message,
        })
      );
      return rejectWithValue(error);
    }
  }
);
